import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import { useAcknowledgeEmergencyViaWebUi } from '~/hooks/api/useAcknowledgeEmergencyViaWebUi';
import messages from './messages';

type AcknowledgeButtonProps = {
  publisherId: number;
};

const AcknowledgeButton = (props: AcknowledgeButtonProps) => {
  const mutation = useAcknowledgeEmergencyViaWebUi();
  return (
    <Button
      variant="contained"
      color="warning"
      onClick={() => {
        mutation.mutate({ publisherId: props.publisherId });
      }}
    >
      <FormattedMessage {...messages.acknowledge} />
    </Button>
  );
};

export default AcknowledgeButton;
